export default __webpack_public_path__ + "static/media/first.72f34cc4.png";